<template>
  <div class="plan-item-2">
    <div class="title">方案详情</div>
    <div class="plan-container">
      <!-- 启动期 -->
      <div class="plan-item">
        <div class="plan-item-top plan-item-top-1">
          <div class="cur-state">{{
            data.complete_plan_data.period_one.name
          }}</div>
          <div class="state"
            >{{ data.complete_plan_data.period_one.title_info.name
            }}<span class="state-num">{{
              data.complete_plan_data.period_one.title_info.sub_name
            }}</span></div
          >
          <div class="tag-list">
            <div
              class="tag-item"
              v-for="(item, index) in data.complete_plan_data.period_one
                .title_info.tag"
              :key="index"
              >{{ item }}</div
            >
          </div>
          <div class="less"
            >目标减重<span class="iconfont icon-web__bitebiyoujiantou"></span
            ><span class="less-num"
              >{{ data.complete_plan_data.period_one.title_info.prev_weight_txt
              }}<span class="less-unit">斤</span></span
            ></div
          >
        </div>
        <div class="state1-content">
          <div
            class="state1-item"
            v-for="(item, index) in data.complete_plan_data.period_one
              .content_list"
            :key="index"
          >
            <div class="state-item-top">
              <div class="state-item-title">{{ item.title_name }}</div>
              <div class="state-item-dash"></div>
              <div class="state-item-num">{{ item.title_num }}</div>
              <div class="state-item-unit">{{ item.title_unit }}</div>
            </div>
            <div class="state1-list">
              <div
                class="state1-list-item"
                v-for="(item1, index1) in item.content_data"
                :key="index1"
                >{{ item1 }}
              </div>
            </div>
            <div class="state1-tips" v-if="item.content_tips"
              >*{{ item.content_tips }}</div
            >
          </div>
        </div>
      </div>
      <!-- 快降期 -->
      <div class="plan-item">
        <div class="plan-item-top plan-item-top-2">
          <div class="cur-state">{{
            data.complete_plan_data.period_two.name
          }}</div>
          <div class="state"
            >{{ data.complete_plan_data.period_two.title_info.name
            }}<span class="state-num">{{
              data.complete_plan_data.period_two.title_info.sub_name
            }}</span></div
          >
          <div class="tag-list">
            <div
              class="tag-item"
              v-for="(item, index) in data.complete_plan_data.period_two
                .title_info.tag"
              :key="index"
              >{{ item }}</div
            >
          </div>
          <div class="less"
            >目标减重<span class="iconfont icon-web__bitebiyoujiantou"></span
            ><span class="less-num"
              >{{ data.complete_plan_data.period_two.title_info.prev_weight_txt
              }}<span class="less-unit">斤</span></span
            ></div
          >
        </div>
        <div class="state2-content">
          <div class="state2-list">
            <div
              class="state2-list-item"
              v-for="(item, index) in data.complete_plan_data.period_two
                .content_list"
              :key="index"
            >
              <div class="state-item-top">
                <div class="state-item-title">{{ item.title_name }}</div>
                <div class="state-item-dash"></div>
                <div class="state-item-num">{{ item.title_num }}</div>
                <div class="state-item-unit">{{ item.title_unit }}</div>
              </div>
            </div>
          </div>
          <div
            class="state2-btn"
            @click="bindConsultCoach"
            v-buried
            data-buried="BG_WFFJZFA_BOTTON_JINXIAN"
            v-clickBuried
            data-click-buried="CLICK_WFFJZFA_BOTTON_JINXIAN"
            ><span class="iconfont icon-weijiesuo"></span
            ><span>联系私人营养师顾问</span></div
          >
          <div class="state2-tips"
            >*{{ data.complete_plan_data.period_two.period_tips }}</div
          >
        </div>
      </div>
      <!-- 稳定期 -->
      <div class="plan-item">
        <div class="plan-item-top plan-item-top-3">
          <div class="cur-state">{{
            data.complete_plan_data.period_three.name
          }}</div>
          <div class="state"
            >{{ data.complete_plan_data.period_three.title_info.name
            }}<span class="state-num">{{
              data.complete_plan_data.period_three.title_info.sub_name
            }}</span></div
          >
          <div class="tag-list">
            <div
              class="tag-item"
              v-for="(item, index) in data.complete_plan_data.period_three
                .title_info.tag"
              :key="index"
              >{{ item }}</div
            >
          </div>
          <div class="less"
            >目标减重<span class="iconfont icon-web__bitebiyoujiantou"></span
            ><span class="less-num"
              >{{
                data.complete_plan_data.period_three.title_info.prev_weight_txt
              }}<span class="less-unit">斤</span></span
            ></div
          >
        </div>
        <div class="state2-content">
          <div class="state2-list">
            <div
              class="state2-list-item"
              v-for="(item, index) in data.complete_plan_data.period_three
                .content_list"
              :key="index"
            >
              <div class="state-item-top">
                <div class="state-item-title">{{ item.title_name }}</div>
                <div class="state-item-dash"></div>
                <div class="state-item-num">{{ item.title_num }}</div>
                <div class="state-item-unit">{{ item.title_unit }}</div>
              </div>
            </div>
          </div>
          <div
            class="state2-btn"
            @click="bindConsultCoach"
            v-buried
            data-buried="BG_WFFJZFA_BOTTON_JINXIAN"
            v-clickBuried
            data-click-buried="CLICK_WFFJZFA_BOTTON_JINXIAN"
            ><span class="iconfont icon-weijiesuo"></span
            ><span>联系私人营养师顾问</span></div
          >
          <div class="state2-tips"
            >*{{ data.complete_plan_data.period_three.period_tips }}</div
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    data: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      list: [
        {
          title: '饮食习惯测评',
          num: '2',
          unit: '日',
          list: [
            '饮食： 明确饮食应激源、血糖波动追踪、饮食偏好',
            '生活习惯：挖掘深层隐性压力、焦虑反应状态、监督程度'
          ],
          tips: ''
        },
        {
          title: '肥胖溯源+体型问题AI诊断',
          num: '2',
          unit: '次',
          list: ['体型与肥胖形成原因的深度分析与解读'],
          tips: ''
        },
        {
          title: '营养师1V1饮食指导',
          num: '21',
          unit: '次',
          list: [
            '控制血糖：坚果、鱼肉与全脂乳制品血糖负荷低的食物',
            '消除食物应激源：加工食品、植物油、麸质食物',
            '滋养肾上腺：高质量符合营养补充剂（如镁、锌、维生素C）',
            '答疑：营养师持续跟进答疑'
          ],
          tips: '*为保证饮食方案用量的精准度，请务必在与营养师沟通后再执行'
        },
        {
          title: '皮质醇平衡课程',
          num: '2',
          unit: '次',
          list: [
            '方向：真正认识肾上腺激素、肾上腺平衡饮食配比、配料表解读、主食挑选法则',
            '目标：搭建系统营养认知，学会规划自身饮食',
            '预计花费时间：35分钟'
          ],
          tips: ''
        }
      ]
    }
  },
  created() {},
  methods: {
    bindConsultCoach() {
      if (this.$betterwe.isApp()) {
        let path =
          '/miniProgram?userName=gh_0d804ee2c21b&path=pages%2Fimage-page%2Findex%3Furl%3Dhttps%253A%252F%252Fcdnvue.gymcity.com.cn%252Fbetterwe_1.0%252Fvue%252F0404d3648554ff897ad70758465dcd93.png'
        this.$betterwe.jumpRoute(path)
      } else {
        this.$router.push('/app-download')
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.plan-item-2 {
  .title {
    position: relative;
    color: rgba(48, 48, 56, 0.7);
    padding-left: 10px;
    font-weight: bold;
    font-size: 16px;
    line-height: 22px;
    margin-bottom: 11px;
  }

  .title::after {
    content: '';
    position: absolute;
    left: 0;
    top: 50%;
    width: 4px;
    height: 20px;
    background-color: rgba(48, 48, 56, 0.3);
    transform: translate(0%, -50%);
  }

  .plan-container {
    border-radius: 6px;
    overflow: hidden;
    background-color: #fff;

    .plan-item {
      .plan-item-top {
        position: relative;
        background-repeat: no-repeat;
        background-size: contain;
        background-position: right center;
        padding: 16px 16px 19px;
        border-radius: 6px 6px 0px 0px;
        overflow: hidden;

        .cur-state {
          position: absolute;
          right: 0;
          top: 0;
          padding: 0px 8px;
          background: rgb(84, 91, 119);
          border-radius: 0px 6px 0px 6px;
          font-weight: bold;
          font-size: 10px;
          line-height: 16px;
          color: #ffffff;
        }

        .state {
          font-family: PingFangSC, PingFang SC;
          font-weight: bold;
          font-size: 20px;
          color: #ffffff;
          line-height: 28px;
          margin-bottom: 2px;

          .state-num {
            font-size: 16px;
          }
        }

        .tag-list {
          width: 180px;
          display: flex;
          flex-wrap: wrap;
          margin-bottom: 9px;

          .tag-item {
            white-space: nowrap;
            height: 19px;
            border-radius: 2px;
            border: 1px solid rgba(255, 255, 255, 0.5);
            box-sizing: border-box;
            padding: 0px 4px;
            font-size: 10px;
            color: #ffffff;
            line-height: 17px;
            margin-right: 4px;
          }
        }

        .less {
          font-weight: bold;
          font-size: 16px;
          color: #ffffff;
          line-height: 22px;

          .iconfont {
            display: inline-flex;
            align-items: center;
            justify-content: center;
            width: 17px;
            height: 17px;
            transform: rotate(90deg);
            margin-left: 2px;
          }

          .less-num {
            font-family: DIN;
            font-weight: bold;
            font-size: 20px;
            color: #ffffff;
            line-height: 26px;
          }

          .less-unit {
            font-size: 16px;
          }
        }
      }
      .plan-item-top-1 {
        background-image: url('https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/a4d6cdd1da77d07c4f9568854f99c74c.png'),
          linear-gradient(137deg, #5ed99d 0%, #21cb88 100%);
      }
      .plan-item-top-2 {
        background-image: url('https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/ce4d9a45a3f1dc5ac091812e8e7d3345.png'),
          linear-gradient(137deg, #5ed99d 0%, #21cb88 100%);
      }
      .plan-item-top-3 {
        background-image: url('https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/b1e81c37d61d4dbe97e43cf985728bda.png'),
          linear-gradient(137deg, #5ed99d 0%, #21cb88 100%);
      }
      .plan-item-top::after {
        content: '';
        position: absolute;
        bottom: 0;
        left: 25px;
        width: 0;
        height: 0;
        border-left: 7px solid transparent;
        border-right: 7px solid transparent;
        border-bottom: 9px solid #fff;
      }

      .state-item-top {
        display: flex;
        align-items: center;
        margin-bottom: 9px;

        .state-item-title {
          font-size: 14px;
          line-height: 20px;
        }

        .state-item-dash {
          flex: 1;
          flex-shrink: 0;
          overflow: hidden;
          height: 1px;
          margin: 0 10px;
          background-image: linear-gradient(
            to right,
            rgba(0, 0, 0, 0.3) 0%,
            rgba(0, 0, 0, 0.3) 16.6%,
            rgba(0, 0, 0, 0) 16.7%,
            rgba(0, 0, 0, 0) 100%
          );
          background-size: 6px 1px;
          background-repeat: repeat-x;
        }

        .state-item-num {
          font-family: DIN;
          font-weight: bold;
          font-size: 17px;
          line-height: 22px;
        }

        .state-item-unit {
          font-size: 14px;
          line-height: 20px;
        }
      }

      .state1-content {
        padding: 17px 17px 10px 15px;

        .state1-item {
          padding-bottom: 21px;

          .state1-list {
            font-size: 10px;
            color: rgba(48, 48, 56, 0.4);
            line-height: 16px;

            .state1-list-item {
              position: relative;
              padding-left: 9px;
              margin-bottom: 10px;
            }

            .state1-list-item::after {
              content: '';
              position: absolute;
              left: 0;
              top: 8px;
              transform: translate(0%, -50%);
              width: 0;
              height: 0;
              border-left: 4px solid rgba(0, 0, 0, 0.25);
              border-bottom: 2px solid transparent;
              border-top: 2px solid transparent;
            }

            .state1-list-item:last-child {
              margin-bottom: 0;
            }
          }

          .state1-tips {
            margin-top: 13px;
            font-size: 9px;
            color: rgba(48, 48, 56, 0.4);
            line-height: 9px;
          }
        }
      }

      .state2-content {
        padding: 16px 16px 30px;

        .state2-list {
          margin-bottom: 26px;

          .state2-list-item {
            margin-bottom: 14px;
          }
        }

        .state2-btn {
          margin-bottom: 10px;
          height: 38px;
          background: linear-gradient(324deg, #373a56 0%, #565e7a 100%);
          border-radius: 22px;
          text-align: center;
          color: #fff;
          font-weight: bold;
          font-size: 14px;
          display: flex;
          align-items: center;
          justify-content: center;
          .iconfont {
            color: #fff;
            width: 16px;
            height: 16px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 14px;
            margin-right: 6px;
          }
        }

        .state2-tips {
          font-size: 10px;
          color: rgba(48, 48, 56, 0.5);
          line-height: 14px;
        }
      }
    }
  }
}
</style>
